import { TableCell, Box, Typography } from "@mui/material";
import NumberFormatterUtils from "../../utils/numberFormatterUtils";

interface Props {
  trend: number;
}

// export const TrendColumn = (props: Props) => {
//   const trendImg: string =
//     props.trend !== undefined && props.trend > 0
//       ? "/img/trend-up-20240109.svg"
//       : "/img/trend-down-20240109.svg";

//   return (
//     <TableCell>
//       <Box display={"flex"}>
//         {!isNaN(props.trend) ||
//           (props.trend !== Infinity ? (
//             <img
//               className={props.trend < 0 ? "status" : undefined}
//               src={trendImg}
//               alt="trend"
//             />
//           ) : undefined)}

//         <Typography
//           variant="text2"
//           color={
//             props.trend === 0 || isNaN(props.trend)
//               ? undefined
//               : props.trend > 0
//               ? "var(--red)"
//               : "var(--status)"
//           }
//         >
//           {props.trend > 0 && props.trend !== Infinity && "+"}
//           {isNaN(props.trend) || props.trend === Infinity
//             ? `0.00%`
//             : `${NumberFormatterUtils.numberFormat(props.trend)}%`}
//         </Typography>
//       </Box>
//     </TableCell>
//   );
// };

export const TrendColumn = (props: Props) => {
  const { trend } = props;

  // กำหนดภาพแนวโน้มที่เหมาะสม
  const trendImg =
    trend > 0 ? "/img/trend-up-20240109.svg" : "/img/trend-down-20240109.svg";

  // ฟังก์ชันสำหรับการจัดการสีของข้อความ
  const getColor = () => {
    if (isNaN(trend) || trend === Infinity) return undefined;
    return trend > 0 ? "var(--red)" : "var(--green)";
  };

  // ฟังก์ชันสำหรับการแสดงค่า trend
  const formatTrend = () => {
    if (isNaN(trend) || trend === Infinity) return "";
    return `${NumberFormatterUtils.numberFormat(trend)}%`;
  };

  // ฟังก์ชันสำหรับการแสดงสัญลักษณ์ + สำหรับ trend บวก
  const renderTrendSign = () => {
    return trend > 0 && trend !== Infinity ? "+" : "";
  };

  return (
    <TableCell>
      <Box display="flex" alignItems="center">
        {/* แสดงภาพแนวโน้ม */}
        {!isNaN(trend) && trend !== Infinity && (
          <img
            className={trend < 0 ? "status" : undefined}
            src={trendImg}
            alt="trend"
          />
        )}

        {/* แสดงข้อความแนวโน้ม */}
        <Typography variant="text2" color={getColor()}>
          {renderTrendSign()}
          {formatTrend()}
        </Typography>
      </Box>
    </TableCell>
  );
};
